import { useState } from 'react';
import ManorShell from './ManorShell';
import { PopupMessage, useStageSubmit } from './StageChrome';

// Stage 1 (stage1.php): press the button -> the clue slides in -> click the
// book -> read the message -> closing it submits the stage (1 point).
// A successful submit updates `game.nextStage`, and ManorShell then routes on.
export default function ManorStage1() {
  const submit = useStageSubmit(1);
  const [phase, setPhase] = useState('start'); // start -> clue -> message

  return (
    <ManorShell bg="stage1/bg.png" bgMob="img/stage1/bg_mob.jpg" stage={1}>
      <img className="manor-drop manor-title" style={{ top: 0, width: '50%' }} src="/manor/img/stage1/title.png" alt="Stage 1" />

      {phase === 'start' && (
        <button type="button" className="manor-img-btn manor-stage1-start" onClick={() => setPhase('clue')}>
          <img src="/manor/img/stage1/button.png" alt="Start" />
        </button>
      )}

      <img
        className={`manor-stage1-clue ${phase === 'clue' ? 'in' : ''}`}
        src="/manor/img/stage1/Clue.png"
        alt="Clue"
      />
      <div className="manor-scenebox">
        <button
          type="button"
          className="manor-img-btn manor-stage1-book"
          disabled={phase !== 'clue'}
          onClick={() => setPhase('message')}
        >
          <img src="/manor/img/stage1/Book.png" alt="Book" />
        </button>
      </div>

      {phase === 'message' && (
        <PopupMessage src="/manor/img/stage1/Stage1_Popupmessage.png" alt="Stage 1 message" onClose={() => submit(1)} />
      )}
    </ManorShell>
  );
}
